var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBhimIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fillRule: "evenodd",
    alt: "Bhim logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.05 32.542 38.715 0l-18.15 64z",
    fill: "#097939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.433 32.542 27.1 0 8.95 64z",
    fill: "#ed752e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhimIcon);
export default __webpack_public_path__ + "static/media/bhimIcon.588fad483bc093191fca2cbfef510abd.svg";
export { ForwardRef as ReactComponent };